import { ProgressBar as FluentProgressBar } from "@fluentui/web-components";
/**
 * ProgressBar
 * @summary A custom progress bar element with customizable thickness, shape, and validation states.
 *
 * @example
 * ```html
 * <fabric-progress-bar thickness="large" shape="rounded" validation-state="success"></fabric-progress-bar>
 * ```
 *
 * @attr {ProgressBarThickness} thickness - The thickness of the progress bar. Possible values are 'medium' and 'large'.
 * @attr {ProgressBarShape} shape - The shape of the progress bar. Possible values are 'rounded' and 'square'.
 * @attr {ProgressBarValidationState} validation-state - The validation state of the progress bar. Possible values are 'success', 'warning', and 'error'.
 *
 * @prop {ProgressBarThickness} thickness - The thickness of the progress bar. Possible values are 'medium' and 'large'.
 * @prop {ProgressBarShape} shape - The shape of the progress bar. Possible values are 'rounded' and 'square'.
 * @prop {ProgressBarValidationState} validationState - The validation state of the progress bar. Possible values are 'success', 'warning', and 'error'.
 *
 * @csspart indicator - The progress bar indicator.
 *
 * @cssprop --indicator-width - Computed percentage width of the progress indicator, based on the current value, min, and max.
 * @cssprop --max - CSS variable reflecting the max attribute value. Defaults to 100.
 * @cssprop --min - CSS variable reflecting the min attribute value. Defaults to 0.
 * @cssprop --value - CSS variable reflecting the current value attribute. Defaults to 0.
 *
 * @extends FluentProgressBar
 * @tagname fabric-progress-bar
 * @public
 */
export class ProgressBar extends FluentProgressBar {
}
//# sourceMappingURL=progress-bar.js.map